var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29370_139)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6511 5.46512H5.46509V54.6512H54.6511V5.46512Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16279 7.55814H0V0H7.55814V1.16279H1.16279V7.55814Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 7.55814H58.8372V1.16279H52.4419V0H60V7.55814Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 60H52.4419V58.8372H58.8372V52.4419H60V60Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55814 60H0V52.4419H1.16279V58.8372H7.55814V60Z",
    fill: "#00739F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_29370_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6504 44H37.585C37.1464 44 36.7908 43.6444 36.7908 43.2058C36.7908 42.7671 37.1464 42.4115 37.585 42.4115H39.6504C41.1728 42.4115 42.4115 41.1729 42.4115 39.6504V20.3496C42.4115 18.8272 41.1729 17.5885 39.6504 17.5885H27.7232C27.2845 17.5885 26.929 17.2329 26.929 16.7942C26.929 16.3556 27.2845 16 27.7232 16H39.6504C42.0488 16 44 17.9512 44 20.3496V39.6504C44 42.0488 42.0488 44 39.6504 44ZM31.8426 44H20.3496C17.9512 44 16 42.0488 16 39.6504V20.3496C16 17.9512 17.9512 16 20.3496 16H22.137C22.5757 16 22.9313 16.3556 22.9313 16.7942C22.9313 17.2329 22.5757 17.5885 22.137 17.5885H20.3496C18.8272 17.5885 17.5885 18.8271 17.5885 20.3496V39.6504C17.5885 41.1728 18.8271 42.4115 20.3496 42.4115H31.8426C32.2812 42.4115 32.6368 42.7671 32.6368 43.2058C32.6368 43.6444 32.2812 44 31.8426 44Z",
    fill: "#63B6D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.716 22.6004L21.5236 28.9105C20.999 29.1149 21.0309 29.8675 21.5708 30.0268L25.2695 31.1188L26.4192 35.4236C26.5795 35.9326 27.2244 36.0868 27.5978 35.7056L29.874 33.5333L34.7015 37.2882C35.2123 37.6631 35.9398 37.3844 36.0695 36.7644L38.834 23.547C38.9694 22.8995 38.3325 22.3602 37.716 22.6004Z",
    fill: "#E9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2143 38.2521H35.2142C34.8597 38.2521 34.5198 38.1402 34.2315 37.9286C34.2256 37.9242 34.2197 37.9198 34.2139 37.9152L29.927 34.5807L28.1541 36.2728C27.8705 36.5565 27.4952 36.7125 27.0955 36.7125C26.4358 36.7125 25.8595 36.2905 25.6617 35.6623C25.6582 35.6511 25.6548 35.6399 25.6518 35.6286L24.6173 31.7545L21.346 30.7886C20.7693 30.6184 20.38 30.1201 20.3546 29.5194C20.3291 28.9184 20.6748 28.389 21.2353 28.1706L37.4278 21.8605C37.6168 21.7863 37.818 21.7482 38.0211 21.748C38.5113 21.748 38.9716 21.9684 39.2838 22.3527C39.5928 22.733 39.7123 23.2277 39.6114 23.7097L36.8468 36.9271C36.6862 37.6948 35.9997 38.2521 35.2143 38.2521ZM35.1762 36.6514C35.1891 36.6599 35.2008 36.6636 35.2143 36.6636C35.2209 36.6636 35.2794 36.6619 35.292 36.6019L38.0566 23.3845C38.0597 23.3696 38.0586 23.3636 38.051 23.3543C38.0427 23.3441 38.0298 23.3364 38.021 23.3364C38.0153 23.3368 38.0097 23.3381 38.0045 23.3404L22.3677 29.434L25.4943 30.3572C25.6249 30.3958 25.7433 30.4672 25.8383 30.5648C25.9333 30.6623 26.0016 30.7825 26.0368 30.914L27.1399 35.0447L29.3256 32.9588C29.4634 32.8274 29.6437 32.7498 29.8339 32.7402C30.024 32.7305 30.2113 32.7896 30.3616 32.9065L35.1762 36.6514Z",
    fill: "#63B6D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0136 35.6989C28.0385 35.7796 28.9484 34.6421 28.9581 34.558L28.55 32.56C28.5236 32.4308 28.5327 32.2969 28.5764 32.1725C28.6201 32.0482 28.6968 31.938 28.7982 31.8537L36.2793 25.6371C36.4593 25.4778 36.2502 25.1969 36.0461 25.3234L27.2486 30.6891C27.1468 30.7512 27.0664 30.843 27.0181 30.952C26.9698 31.0611 26.956 31.1823 26.9785 31.2995L28.0136 35.6989Z",
    fill: "#63B6D4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29370_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_29370_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.01c3171beae2f0ff1863d70a874b032d.svg";
export { ForwardRef as ReactComponent };